import { Link } from "react-router-dom";
import classNames from "classnames";
import styles from "./Clickable.module.css";

interface ClickableProps extends React.PropsWithChildren {
  link?: string;
  active?: boolean;
  color?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const Clickable: React.FC<ClickableProps> = ({
  onClick,
  link,
  active,
  color = "#1565c0",
  style: styleProp,
  children: childrenProp,
}) => {
  const className = classNames(styles.container, active && styles.active);
  const style = { "--overlay": color, ...styleProp };
  const props = { className, style };

  const children = (
    <>
      {childrenProp}
      <span className={styles.overlay} />
    </>
  );

  if (link) {
    return (
      <Link {...props} to={link}>
        {children}
      </Link>
    );
  } else if (onClick) {
    return (
      <button {...props} onClick={onClick}>
        {children}
      </button>
    );
  } else {
    return children;
  }
};

export { Clickable };
